const Dropdown = {
    baseStyle: {
        display: 'inline-flex',
        w: '100%',
    },
    defaultProps: {
        variant: 'labelLeft',
    },
    variants: {
        labelFloat: {},
        labelLeft: {
            alignItems: 'center',
            flexDirection: 'row',
            label: {
                mb: 0,
            },
        },
        labelTop: {
            flexDirection: 'column',
            label: {
                mr: 0,
            },
        },
    },
};
export default Dropdown;
